import { render, staticRenderFns } from "./refferalPartner.vue?vue&type=template&id=95e7cb50&scoped=true&"
import script from "./refferalPartner.vue?vue&type=script&lang=js&"
export * from "./refferalPartner.vue?vue&type=script&lang=js&"
import style0 from "./refferalPartner.vue?vue&type=style&index=0&id=95e7cb50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95e7cb50",
  null
  
)

export default component.exports